<script setup lang="ts">
import { RouterView } from 'vue-router'
import { onMounted } from 'vue'

// 導入全域樣式
import '@/assets/styles/global.scss'

onMounted(() => {
  // 設置預設的 meta 標籤
  const metaDescription = document.querySelector('meta[name="description"]')
  if (!metaDescription) {
    const meta = document.createElement('meta')
    meta.name = 'description'
    meta.content = '消防員地中海飲食指南 - 專為消防員設計的健康飲食指南，結合地中海飲食的營養優勢，幫助消防員保持最佳體能狀態。'
    document.head.appendChild(meta)
  }

  // 設置其他 SEO meta 標籤
  const metaKeywords = document.createElement('meta')
  metaKeywords.name = 'keywords'
  metaKeywords.content = '消防員,地中海飲食,健康飲食,營養指南,健康食譜,消防員健康,職業健康'
  document.head.appendChild(metaKeywords)

  const metaAuthor = document.createElement('meta')
  metaAuthor.name = 'author'
  metaAuthor.content = 'FireHealth Team'
  document.head.appendChild(metaAuthor)

  // Open Graph meta 標籤
  const ogTitle = document.createElement('meta')
  ogTitle.setAttribute('property', 'og:title')
  ogTitle.content = 'FireHealth - 消防員地中海飲食指南'
  document.head.appendChild(ogTitle)

  const ogDescription = document.createElement('meta')
  ogDescription.setAttribute('property', 'og:description')
  ogDescription.content = '專為消防員設計的健康飲食指南，結合地中海飲食的營養優勢，幫助消防員保持最佳體能狀態。'
  document.head.appendChild(ogDescription)

  const ogType = document.createElement('meta')
  ogType.setAttribute('property', 'og:type')
  ogType.content = 'website'
  document.head.appendChild(ogType)
})
</script>

<template>
  <div id="app">
    <RouterView />
  </div>
</template>

<style>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  max-width: none;
}

#app > * {
  flex: 1;
}
</style>
